import ShieldCheck from 'lucide-react/dist/esm/icons/shield-check'
import Lock from 'lucide-react/dist/esm/icons/lock'

/** Reassurance card explaining that uploads are encrypted and access-restricted to the Mezza risk team. */
export function SecurityCard() {
  return (
    <div className="rounded-2xl border border-border/60 bg-white p-5 shadow-[0_2px_16px_rgba(0,0,0,0.04)]">
      <div className="flex items-center gap-2.5">
        <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-success-bg/60">
          <ShieldCheck className="h-5 w-5 text-success-border" />
        </span>
        <p className="text-sm font-semibold text-foreground">Bank-level security</p>
      </div>
      <p className="mt-3 text-xs leading-relaxed text-muted-foreground">
        Files are uploaded over an encrypted connection and saved automatically. Only Mezza&apos;s risk
        team can access them.
      </p>
      <div className="mt-3 flex items-center gap-1.5 text-xs font-medium text-muted-foreground">
        <Lock className="h-3.5 w-3.5 text-success-border" />
        256-bit encrypted connection
      </div>
    </div>
  )
}
